import { styled } from 'styled-components';

export const fieldContainerMarginBlockEnd = '30px';
export const FieldContainer = styled.div`
  margin-bottom: ${fieldContainerMarginBlockEnd};
`;
